import { AxiosInstance } from 'axios'

interface IProfileBannerData {
  dismissed_date?: string
  last_profile_visit?: string
}

export function profileBannerApiFactory(api: AxiosInstance) {
  const baseUrl = '/web/api/v2/profile-banner'
  const methods = {
    getProfileBannerData() {
      return api.get<IProfileBannerData>(baseUrl)
    },
    setProfileBannerData(data: IProfileBannerData) {
      return api.post<IProfileBannerData>(baseUrl, data)
    }
  }
  return methods
}
